import { ArrowDown, MapPin } from "lucide-react";
import Reveal from "@/components/Reveal";
import { MAPS_URL } from "@/constants/links";

const flow = [
  { name: "STORAGE FACILITY", testId: "flow-storage" },
  { name: "TANKER TRUCK / TRANSPORTATION", testId: "flow-transport" },
  { name: "TANJUNG TEMBAGA PORT / REGIONAL DISTRIBUTION", testId: "flow-port" },
  { name: "INDUSTRIAL / EXPORT LOGISTICS", testId: "flow-logistics" },
];

const Location = () => (
  <section id="location" data-testid="location-section" className="scroll-mt-20 bg-ujn-deep text-ujn-offwhite">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:py-28 lg:px-8">
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <p className="font-mono text-[11px] tracking-[0.28em] text-ujn-subtle">OPERATIONS &amp; LOCATION</p>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
              STRATEGICALLY LOCATED IN PROBOLINGGO
            </h2>
          </Reveal>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-ujn-offwhite/75">
            Convenient road access to Tanjung Tembaga Port and regional transportation routes.
          </p>

          <div className="mt-10">
            {flow.map((step, i) => (
              <div key={step.testId}>
                <div
                  data-testid={step.testId}
                  className="flex items-center gap-4 border border-ujn-accent/30 px-5 py-4"
                >
                  <span className="font-mono text-xs tracking-[0.2em] text-ujn-subtle">0{i + 1}</span>
                  <span className="font-heading text-sm font-semibold tracking-wide sm:text-base">{step.name}</span>
                </div>
                {i < flow.length - 1 && (
                  <div className="flex justify-start py-1 pl-8">
                    <ArrowDown className="h-4 w-4 text-ujn-subtle" />
                  </div>
                )}
              </div>
            ))}
          </div>

          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="location-directions-button"
            className="mt-10 inline-flex items-center gap-2.5 bg-ujn-medium px-7 py-4 font-mono text-xs font-semibold tracking-[0.16em] text-ujn-offwhite transition-colors duration-200 hover:bg-ujn-accent"
          >
            <MapPin className="h-4 w-4" />
            GET DIRECTIONS
          </a>
        </div>

        <Reveal delay={0.15} className="flex flex-col justify-center">
          <div className="border border-ujn-accent/30">
            <img
              src="/assets/tank-pumps.webp"
              alt="UJN tank farm facility with access road and tanker truck in Probolinggo"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="mt-4 flex items-center justify-between border border-ujn-accent/30 px-5 py-4">
            <span className="font-mono text-[10px] tracking-[0.22em] text-ujn-subtle">FACILITY ACCESS ROAD</span>
            <span className="font-mono text-[10px] tracking-[0.22em] text-ujn-offwhite/60">PROBOLINGGO, EAST JAVA</span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Location;
